import DocumentPortalView from '../example/views/DocumentPortalView.vue';
import ClientPortal from './views/ClientPortal.vue';
import DocumentPortalSetupView from './views/DocumentPortalSetupView.vue';
import DocumentPortalSetupWelcomeView from './views/DocumentPortalSetupWelcomeView.vue';
import DocumentPortalSetupConfigureView from './views/DocumentPortalSetupConfigureView.vue';
import DocumentPortalSetupDossierView from './views/DocumentPortalSetupDossierView.vue';
import DocumentPortalSetupChecklistView from './views/DocumentPortalSetupChecklistView.vue';
import DocumentPortalSetupQuestionnairesView from './views/DocumentPortalSetupQuestionnairesView.vue';
import DocumentPortalSetupPreviewView from './views/DocumentPortalSetupPreviewView.vue';
import DocumentPortalSetupLinkView from './views/DocumentPortalSetupLinkView.vue';

const clientPortalRoutes = [
  {
    path: '/portal/:firmSlug/:advisorSlug/:entityExternalId',
    name: 'client-portal',
    component: ClientPortal,
    props: route => ({
      firmSlug: route.params.firmSlug,
      advisorSlug: route.params.advisorSlug,
      entityExternalId: route.params.entityExternalId,
      portalType: 'client',
      redirect: route.query.redirect,
    }),
    meta: {
      requiresAuth: false,
      showNav: false,
      showFooter: false,
    },
  },
  {
    path: '/visitor/invitation/:token',
    name: 'public-invitation-preview',
    component: DocumentPortalView,
    props: route => ({
      token: route.params.token,
      previewMode: true,
    }),
    meta: {
      requiresAuth: false,
      showNav: false,
      showFooter: false,
    },
  },
  {
    path: '/client/verify',
    name: 'client-verify',
    component: DocumentPortalView,
    props: route => ({
      token: route.query.token,
      entityExternalId: route.query.entityExternalId,
      advisorSlug: route.query.advisor,
    }),
    meta: {
      requiresAuth: false,
      showNav: false,
      showFooter: false,
      clientOnly: true,
    },
  },
  {
    path: '/client/dashboard',
    name: 'client-dashboard',
    component: DocumentPortalView,
    props: route => ({
      entityExternalId:
        route.query.entity || localStorage.getItem('preview_entity') || '',
      advisorSlug:
        route.query.advisor || localStorage.getItem('preview_advisor') || '',
    }),
    meta: {
      requiresAuth: false,
      clientOnly: true,
    },
  },
  {
    path: '/advisor/client-portal/dashboard/:firmSlug/:advisorSlug/:entityExternalId',
    name: 'advisor-client-portal-dashboard',
    component: DocumentPortalView,
    props: route => ({
      firmSlug: route.params.firmSlug,
      advisorSlug: route.params.advisorSlug,
      entityExternalId: route.params.entityExternalId,
      advisorView: true,
      previewMode: false,
      // redirect: route.query.redirect
    }),
    meta: {
      requiresAuth: false,
      advisorOnly: true,
      showNav: false,
      showFooter: false,
    },
  },
  {
    path: '/advisor/client-portal/setup/:firmSlug/:advisorSlug/:entityExternalId',
    name: 'advisor-client-portal-setup',
    component: DocumentPortalSetupView,
    props: route => ({
      firmSlug: route.params.firmSlug,
      advisorSlug: route.params.advisorSlug,
      entityExternalId: route.params.entityExternalId,
      advisorView: true,
    }),
    meta: {
      requiresAuth: false,
      advisorOnly: true,
      showNav: false,
      showFooter: false,
    },
    children: [
      {
        name: 'advisor-client-portal-setup-configure',
        path: 'configure',
        component: DocumentPortalSetupConfigureView,
        props: true,
        children: [
          {
            name: 'advisor-client-portal-setup-welcome',
            path: '',
            component: DocumentPortalSetupWelcomeView,
            props: true,
          },
          {
            name: 'advisor-client-portal-setup-dossier',
            path: 'dossier',
            component: DocumentPortalSetupDossierView,
            props: true,
          },
          {
            name: 'advisor-client-portal-setup-checklist',
            path: 'checklist',
            component: DocumentPortalSetupChecklistView,
            props: true,
          },
          {
            name: 'advisor-client-portal-setup-questionnaires',
            path: 'questionnaires',
            component: DocumentPortalSetupQuestionnairesView,
            props: true,
          },
        ],
      },
      {
        name: 'advisor-client-portal-setup-preview',
        path: 'preview',
        component: DocumentPortalSetupPreviewView,
        props: true,
      },
      {
        name: 'advisor-client-portal-setup-link',
        path: 'link',
        component: DocumentPortalSetupLinkView,
        props: true,
      },
    ],
  },
];

export default clientPortalRoutes;
